'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = quoteValueIfNeeded;


var quotedProperties = ['content'];

function quoteValueIfNeeded(property, value) {
  return quotedProperties.indexOf(property) >= 0 ? '"' + value + '"' : value;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/radium/lib/quote-value-if-needed.js
// module id = 555
// module chunks = 0